module.exports = __webpack_public_path__ + "static/specialists-slideshow-03@2x-d442779d7723fa541f324d3abbe1b039.jpg";